export type IssueStatus = 'New' | 'In Progress' | 'Done' | 'Archived';

export type IssuePriority = 'Low' | 'Medium' | 'High';

export type IssueViewType = 'kanban' | 'list';

export interface User {
  id: string;
  name: string;
  email: string;
  photoURL?: string;
}

export interface Reference {
  type: 'user' | 'customer' | 'issue' | 'comment';
  id: string;
  display: string;
  metadata?: {
    [key: string]: any;
  };
}

export interface Comment {
  id: string;
  content: string;
  createdAt: string;
  updatedAt?: string;
  createdBy: User;
  editedBy?: User;
  parentId?: string; // For threaded comments
  mentions?: Reference[];
  references?: Reference[];
  reactions?: {
    [key: string]: User[]; // emoji: users who reacted
  };
  threadCount?: number;
}

export interface IssueActivity {
  id: string;
  type: 'status_change' | 'priority_change' | 'assignment' | 'comment' | 'update';
  content: string;
  createdAt: string;
  createdBy: {
    id: string;
    name: string;
    email: string;
    photoURL?: string;
  };
  metadata?: {
    oldValue?: string;
    newValue?: string;
  };
}

export interface Issue {
  id: string;
  title: string;
  description: string;
  status: IssueStatus;
  priority: IssuePriority;
  createdAt: string;
  createdBy: {
    id: string;
    name: string;
    email: string;
    photoURL?: string;
  };
  updatedAt: string;
  updatedBy?: {
    id: string;
    name: string;
    email: string;
    photoURL?: string;
  };
  assignedTo: {
    id: string;
    name: string;
    email: string;
    photoURL?: string;
  }[];
  completedAt?: string;
  comments: Comment[];
  activity: IssueActivity[];
  archivedAt?: string;
  attachments: {
    id: string;
    url: string;
    name: string;
    type: string;
    createdAt: string;
  }[];
}

export const ISSUE_STATUSES: IssueStatus[] = ['New', 'In Progress', 'Done', 'Archived'];
export const VISIBLE_STATUSES: IssueStatus[] = ['New', 'In Progress', 'Done'];
export const ISSUE_PRIORITIES: IssuePriority[] = ['Low', 'Medium', 'High'];

export const STATUS_COLORS = {
  'New': 'bg-blue-500/10 text-blue-500 border-blue-500/20',
  'In Progress': 'bg-yellow-500/10 text-yellow-500 border-yellow-500/20',
  'Done': 'bg-green-500/10 text-green-500 border-green-500/20',
  'Archived': 'bg-gray-500/10 text-gray-500 border-gray-500/20'
} as const;

export const PRIORITY_COLORS = {
  'High': 'bg-red-500/10 text-red-500 border-red-500/20',
  'Medium': 'bg-yellow-500/10 text-yellow-500 border-yellow-500/20',
  'Low': 'bg-green-500/10 text-green-500 border-green-500/20'
} as const; 